import React from "react";
import styled from "styled-components";
import { IconContext } from "react-icons";
import * as ReactIcons from "react-icons/fa";

interface RoundedButtonProps {
  title: string;
  icon: string;
  children?: React.ReactNode;
  onClick?: () => void;
}

const Button: React.FC<RoundedButtonProps> = ({ title, icon, onClick }) => {
  const IconComponent = ReactIcons[icon as keyof typeof ReactIcons];

  return (
    <StyledRoundedButton onClick={onClick} $hasIcon={true}>
      {icon && (
        <ButtonIcon value={{ className: "icon" }}>
          <IconComponent />
        </ButtonIcon>
      )}
      {title}
    </StyledRoundedButton>
  );
};

interface StyledButtonProps {
  $hasIcon: boolean;
}

// Base style for the rounded button
const baseButtonStyle = `
  display: inline-flex;
  align-items: center;
  padding: 0 1.3rem;
  font-size: 100%;
  line-height: 24px;
  height: 2.5rem;
  margin-right: 10px;
  border: none;
  border-radius: 9999px;
  cursor: pointer;
`;

const StyledRoundedButton = styled.div<StyledButtonProps>`
  ${baseButtonStyle}
  background-color: ${({ theme }) => theme.buttonBgColor};
  color: ${({ theme }) => theme.buttonTextColor};

  &:hover {
    background-color: ${({ theme }) => theme.buttonBgColor};
  }

  svg {
    margin-right: ${({ $hasIcon }) => ($hasIcon ? ".7em" : "0")};
  }
`;

const ButtonIcon = styled(IconContext.Provider)`
  font-size: 24px;
  margin-bottom: 5px;
`;

export default Button;
